"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationIcon = void 0;
var react_1 = __importDefault(require("react"));
var icons_1 = require("@material-ui/icons");
var core_1 = require("@material-ui/core");
var classnames_1 = __importDefault(require("classnames"));
var useStyles = core_1.makeStyles(function (theme) {
    var navigationIcon = theme.variables.palette.modulePanel.navigationIcon;
    return {
        navigationIcon: {
            color: navigationIcon.color,
        },
    };
});
var NavigationIcon = function (props) {
    var setPopoverOpen = props.setPopoverOpen;
    var classes = useStyles();
    return (react_1.default.createElement(core_1.IconButton, { color: "secondary", onClick: setPopoverOpen, className: classnames_1.default(classes.navigationIcon, 't-navigation') },
        react_1.default.createElement(icons_1.Apps, null)));
};
exports.NavigationIcon = NavigationIcon;
